<template>
    <div class="flex flex-col gap-[15px]">
        <p class="m-0 text-[14px] font-normal font-poppins text-[#333333]">Please enter your information and service
            address below.</p>
        <div class="grid grid-cols-1 tablet:grid-cols-2 gap-[15px] tablet:gap-[30px]">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="phone">Phone<span class="ml-1 text-red-500">*</span></label>
                <inputComponent ref="phoneRef" name="phone" required mask="(###) ###-####" placeholder="Phone"
                    type="tel" v-model="consumer.phone" error-message="Invalid Phone Number"
                    :disabled="consumer.phone.length > 0"
                    customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="email">Email<span class="ml-1 text-red-500">*</span></label>
                <inputComponent :disabled="isEmailDisabled()" ref="emailRef" name="email" required 
                :regex="$constants.EMAIL_REGEX" placeholder="Email"
                    v-model="consumer.email" error-message="Invalid Email"
                                customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
        </div>


        <div class="grid grid-cols-1 tablet:grid-cols-2 gap-[15px] tablet:gap-[30px]">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="customFullName">First
                    Name<span class="ml-1 text-red-500">*</span></label>
                <inputComponent ref="firstNameRef" name="firstName" required placeholder="First Name" length="120"
                    v-model="consumer.first_name" :disabled="consumer.first_name.length > 0"
                    customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="customFullName">Last
                    Name<span class="ml-1 text-red-500">*</span></label>
                <inputComponent ref="lastNameRef" name="lastName" required placeholder="Last Name" length="120"
                    v-model="consumer.last_name" :disabled="consumer.last_name.length > 0"
                    customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
        </div>
        <div class="grid grid-cols-1">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="address">Service Address<span class="ml-1 text-red-500">*</span></label>
                <GoogleAutoComplete v-model="selectedServiceAddress.address" placeholder="Address"
                    @place-selected="handlePlace" @address-reset="resetSelectedAddress"
                    :input-class="'w-full px-3 py-[6px] !rounded-[10px] outline-none font-poppins text-[16px] placeholder:text-[#CCCCCC] text-[#333]'" />
                <p v-if="!selectedServiceAddress?.lat && isValidate" class="text-red-500 text-xs mb-0">This field
                    is required.</p>
            </div>
        </div>
        <div class="grid grid-cols-1">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="customFullName">Apt./
                    Unit#<span class="ml-[8px] text-[#999999]">Optional</span></label>
                <inputComponent ref="unit" name="unit" placeholder="Apt./ Unit#" length="120"
                    v-model="selectedServiceAddress.address_line2"
                    customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
        </div>
        <div class="grid grid-cols-1 tablet:grid-cols-2 gap-[15px] tablet:gap-[30px]">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="city">City<span class="ml-1 text-red-500">*</span></label>
                <inputComponent disabled ref="city" name="city" required placeholder="City"
                    v-model="selectedServiceAddress.city" errorMessage="Invalid city"
                    customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="zipCode">Zip Code<span class="ml-1 text-red-500">*</span></label>
                <inputComponent disabled ref="zipCode" name="zipCode" required placeholder="Zip Code"
                    v-model="selectedServiceAddress.zip_code" errorMessage="Invalid zip code"
                    customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
        </div>
        <div class="grid grid-cols-1">
            <div class="flex flex-col gap-[3px]">
                <label class="text-[14px] tablet:text-[14px] font-normal font-poppins text-[#666666] w-full"
                    for="state">State<span class="ml-1 text-red-500">*</span></label>
                <inputComponent disabled ref="state" name="state" placeholder="State" length="120"
                    v-model="selectedServiceAddress.state" errorMessage="Invalid state"
                    customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full rounded-[10px] border border-[#cccccc] placeholder:text-[#CCCCCC] text-[#333]" />
            </div>
        </div>
    </div>
    <div class="flex justify-center mt-[30px] pb-2.5">
        <button @click="submitForm"
            class="CustomBlueBtn flex items-center gap-[12px] px-[20px] py-[8px] text-[16px] font-poppins rounded-full transition duration-300 border-[1px] border-customBlue-100 mobile:text-white laptop:text-customBlue-100 !text-[#fff] !bg-customBlue-100 laptop:bg-white laptop:hover:bg-gradient-to-r laptop:from-[#2459A8] laptop:to-[#117EC2] laptop:hover:text-[#fff]">
            <span>Continue to Billing </span> <img src="../../../assets/images/arrow-white-icon.svg" alt="Arrow Icon" class="w-[16px] h-[16px]"></button>
    </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import inputComponent from '../../partialComponent/inputComponent.vue';
import GoogleAutoComplete from '../../partialComponent/GoogleAutoComplete.vue';
import { useToast } from "vue-toastification";
import { faListNumeric } from "@fortawesome/free-solid-svg-icons";
const toast = useToast();

export default {
    components: {
        inputComponent,
        GoogleAutoComplete
    },
    emits: ["submitDetail"],
    data() {
        let user = this.$helper.getUserItem();
        return {
            isValidate: false,
            consumer: {
                name: null,
                first_name: this.$helper.getUserItem()?.user.first_name ?? "",
                last_name: this.$helper.getUserItem()?.user.last_name ?? "",
                phone: this.$helper.getUserItem()?.user.phone ?? "",
                email: this.$helper.getUserItem()?.user.email ?? "",
            },
            email : this.$helper.getUserItem()?.user.email ?? "",
            selectedServiceAddress: {
                "address": null,
                "address_line1": null,
                "address_line2": null,
                "city": null,
                "state": null,
                "zip_code": null,
                "country": null,
                "lat": null,
                "lng": null
            },
        };
    },
    computed: {
        ...mapGetters([
            "formattedAddress", "userObject"
        ]),

    },

    watch: {
        formattedAddress: function (data) {
            this.selectedServiceAddress = {
                "address": this.formattedAddress.address,
                "address_line1": this.formattedAddress.street,
                "address_line2": this.formattedAddress.address_2,
                "city": this.formattedAddress.city_id,
                "state": this.formattedAddress.state_id,
                "zip_code": this.formattedAddress.postal_code,
                "country": this.formattedAddress.country_name,
                "lat": this.formattedAddress.lat,
                "lng": this.formattedAddress.long
            }
        },
        userObject: function (data) {

            let user1 = this.$helper.getUserItem().user;
            this.consumer = {
                name: null,
                first_name: user1.first_name ?? "",
                last_name: user1.last_name ?? "",
                phone: user1.phone ?? "",
                email: user1.email ?? "",
            }

            this.email = this.consumer.email

        }

    },

    methods: {
        ...mapActions([
            "getFormattedAddress",
        ]),

        setData(data) {
            this.consumer = data.consumer
            this.selectedServiceAddress = data.service_address
        },

        isEmailDisabled(){
            let status = false

            if(this.email.length > 0){
                status = true
            }
        
            return status
        },

        resetSelectedAddress() {
            this.selectedServiceAddress = {
                "address": null,
                "address_line1": null,
                "address_line2": null,
                "city": null,
                "state": null,
                "zip_code": null,
                "country": null,
                "lat": null,
                "lng": null
            }
        },

        handlePlace(place) {
            this.getFormattedAddress({
                address: place.formatted_address,
                lat: place.geometry?.location?.lat(),
                lng: place.geometry?.location?.lng(),
            })
        },

        validateForm() {
            this.isValidate = true
            let inputRefer = ["firstNameRef", "lastNameRef", "phoneRef", "emailRef", "city", "zipCode", "state"]
            let hasError = false;
            let firstInvalidField = null;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError && !firstInvalidField) {
                        firstInvalidField = inputComponent; // Store first invalid field
                    }
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });
            if (
                this.$helper.isEmpty(this.consumer.phone) ||
                this.$helper.isEmpty(this.consumer.first_name) ||
                this.$helper.isEmpty(this.consumer.last_name) ||
                this.$helper.isEmpty(this.consumer.email)
            ) {
                // toast.error("Please fill all required fields.");
                hasError = true;
            }

            if (firstInvalidField) {
                this.$nextTick(() => {
                    firstInvalidField.$el.scrollIntoView({ behavior: "smooth", block: "center" });
                    firstInvalidField.$el.querySelector("input").focus();
                });
            }

            if ((this.selectedServiceAddress?.lat ?? 0) == 0) {
                hasError = true;
            } else if (
                this.$helper.isEmpty(this.selectedServiceAddress.city) ||
                this.$helper.isEmpty(this.selectedServiceAddress.state) ||
                this.$helper.isEmpty(this.selectedServiceAddress.zip_code)
            ) {
                toast.error("This address is invalid. Please select a different address.");
                hasError = true;
            }

            return hasError;
        },

        submitForm() {
            if (!this.validateForm()) {
                this.consumer['name'] = this.consumer.first_name + " " + this.consumer.last_name
                let formData = {
                    consumer: this.consumer,
                    service_address: this.selectedServiceAddress
                }
                this.$emit('submitDetail', formData);
            }
        },

        getAddress() {
            return this.selectedServiceAddress ?? null
        }


    }
}
</script>
